import {basicColor} from '@/styles/template';

export default {
    title: 'light',

    boxShadow: {
        Small: '0px 1px 2px rgba(0, 0, 0, 0.05)',
        Normal: '1px 33px 20px rgba(166, 176, 185, 0.0920837)',
        Middle: '8px 14px 21px rgba(163, 172, 181, 0.23)',
        Long: '-1px -33px 20px rgba(166, 176, 185, 0.0920837), 0px 50px 64px rgba(186, 194, 202, 0.4)',
        Extreme: '1px 50px 64px rgba(24, 29, 79, 0.15), -1px -2px 20px rgba(24, 29, 79, 0.1)',
    },

    color: {
        Text: basicColor.black,
        LightItem: basicColor.faintGray,
        MidtoneItem:  basicColor.midGray,
        Item: basicColor.white,
        Background: basicColor.lightGrey,
        Overlay: basicColor.transparent,
    }
}